import React from "react";
import "./Home.scss";
import { NavLink } from "react-router-dom";
import sideFoodImg1 from "../../../Assets/Images/side-food-img1.jpg";
import sideFoodImg2 from "../../../Assets/Images/side-food-img2.jpg";
import sideFoodImg3 from "../../../Assets/Images/side-food-img3.jpg"; 
import HomeBanner from "../../../Assets/Images/home-banner.jpg"; 
import galleryImg from "../../../Assets/Images/gallery-img.jpg";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export default function Home() {
  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 1000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
        <div className="container">
          <div className="new-hero-banner-design">
              <img src={HomeBanner} alt="HomeBanner"/>
          </div>
        </div>
    

      {/* <section className='sectionPadding post_wrap'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='image_box textCenter overlay responsiveSpace'>
                <div className='contentWrap'>
                  <span>Menus</span>
                  <h2>Book A <br/>Table</h2>
                  <div className='defultBtn'>
                    <a href="#">Reservation</a>
                  </div>
                </div>                
              </div>
            </div>
            <div className='col-md-6'>
              <div className='image_box textCenter overlay'>
                <div className='contentWrap'>
                  <span>Hungry?</span>
                  <h2>Start your <br/>experience today</h2>
                  <div className='defultBtn'>
                    <a href="#">Menus</a>
                  </div>
                </div>                
              </div>
            </div>
          </div>
        </div>        
      </section> */}
      <section className="sectionPadding aboutUs_wrap lightBg">
        <div className="container">
          <div className="row">
            <div className="col-md-5 responsiveSpace">
              <div className="titleBox">
                <span>Gallery</span>
                <h2>Fresh and local perfect food for you</h2>
              </div>
              <p>
                This kitchen is a brewery of life – whether it’s the kids baking
                parties or their parents elaborate soirees, there’s always
                something cooking in here.
              </p>
              <div className="aboutBtn">
                <NavLink to="/aboutus">About us</NavLink>
              </div>
            </div>
            <div className="col-md-5">
              <div className="aboutImage textCenter responsiveSpace">
                <div className="middleBox">
                  <h3>
                    Let’s build something amazing. We’re ready when you are.
                  </h3>
                  <p>
                    We only hire great people who strive to push their ideas
                    into fruition by outmuscling and outhustling the
                    competition.
                  </p>
                  <div className="aboutBtn">
                    <a href="#">
                      Read more <i class="fa-solid fa-angle-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="lastImage">
                <div className="firstBox">
                  <img src={sideFoodImg1} />
                </div>
                <div className="firstBox">
                  <img src={sideFoodImg2} />
                </div>
                <div className="firstBox">
                  <img src={sideFoodImg3} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sectionPadding branchName overlayBg">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="branchName_inner_wrap textCenter">
                <h2>Start your experience</h2>
                <h3>Always happy to see you</h3>
                <div className="defultBtn">
                  <a href="#">Get direction</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sectionPadding aboutUs_wrap lightBg gallery_wrap">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="gallery_box responsiveSpace">
                <a href="#">
                  <img src={galleryImg} />
                  <div className="info">
                    <span className="sub-title">
                      Dessert / Events / Fish / Meat
                    </span>
                    <h4>Classic CheeseCake</h4>
                    <p>Seasonal Flavours</p>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="titleBox">
                <span>Eat with us</span>
                <h2>Our priority is to offer a warm welcome</h2>
              </div>
              <p>
                This kitchen is a brewery of life – whether it’s the kids baking
                parties or their parents elaborate soirees, there’s always
                something cooking in here.
              </p>
              <div className="aboutBtn">
                <a href="#">Gallery</a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sectionPadding aboutUs_wrap textCenter darkBg">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="titleBox tableBox">
                <span>Reserve your table today</span>
                <h2>About Us</h2>
                <p className="mb-0">
                  This kitchen is a brewery of life – whether it’s the kids
                  baking parties or their parents elaborate soirees, there’s
                  always something cooking in here. Offering stylish and modern
                  European cuisine served with exquisite attention to detail and
                  immaculate presentation.
                </p>
                {/* <div className='aboutBtn'>
                  <a href="#">Book A Table</a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
